import { useState, useEffect } from 'react';
import css from './CookieBlockedMap.module.css';

const CookieBlockedMap = ({ children }) => {
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    if (
      window.Cookiebot &&
      window.Cookiebot.consent &&
      window.Cookiebot.consent?.marketing
    ) {
      setHasConsent(true);
    }

    const onConsentGiven = () => {
      if (window.Cookiebot.consent && window.Cookiebot.consent?.marketing) {
        setHasConsent(true);
      }
    };

    window.addEventListener('CookiebotOnAccept', onConsentGiven);

    return () => {
      window.removeEventListener('CookiebotOnAccept', onConsentGiven);
    };
  }, []);

  if (!hasConsent) {
    return (
      <div className={css.cookieConsentPlaceholderContainer}>
        <div className={css.cookiePlaceholder}>
          <p className={css.cookiePlaceholderText}>
            Please{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.Cookiebot.renew();
              }}
            >
              accept marketing cookies
            </a>{' '}
            to view this map.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default CookieBlockedMap;
